export default __webpack_public_path__ + "static/media/tech5-white-logo.aea8c140.svg";